import { useMutation } from "@/api/utils/useQuery"
import { ApiGatewayMutations } from "@/api/apiGateway/mutations"
import { HasuraMutations } from "@/api/hasura/mutations"
import { InsertCancellationReasonMutationVariables } from "@/api/hasura/generated/graphql"
import {
  ICreateCancellationReasonPayload,
  IUpdateCancellationReasonPayload,
} from "./CancellationReasonMutator.types"

class CancellationReasonMutatorClass {
  create() {
    return useMutation({
      ...HasuraMutations.cancellationReason.create(),
      serializerFn: (
        data: ICreateCancellationReasonPayload,
      ): InsertCancellationReasonMutationVariables => ({
        billingAccountId: data.billingAccountId,
        channel: data.channel,
        meterPointId: data.meterpointId,
        details: data.details,
      }),
    })
  }

  update() {
    return useMutation({
      ...ApiGatewayMutations.cancellationReason.update(),
      serializerFn: (data: IUpdateCancellationReasonPayload) => {
        return {
          id: data.id,
          reasonDetail: data.reasonDetail,
        }
      },
    })
  }
}

export const CancellationReasonMutator = new CancellationReasonMutatorClass()
